import {
  Box,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import ServicesImg from "../public/img/service.jpg";
import { Icon } from "@iconify/react/dist/iconify.js";
import Footer from "./footer";

export const Services = (props) => {
  return (
    <Box sx={{mt:-10, bgcolor:"#d9d9d9"}}>
      <Container>
        {/* Services */}
        <Box sx={{ py: 2, padding: {xs: 4, sm: 4,  md: 4,} }}>
          <div
            id="portfolio"
            className="text-center"
            style={{ marginTop: -40 ,marginBottom:-90}}
          >
            <div className="container">
              <Box className="section-title">
                <h2> <span style={{ color: "#03203f" }}>Our</span>  <span style={{ color: "#009bd6" }}>Services</span></h2>
              </Box>
            </div>
          </div>
          <Grid container spacing={4}>
            <Grid item md={4} xs={12}>
              <Box sx={{ mt: 3 }}>
                <div className="imagee-div">
                <img
                  className="imagee2"
                  src={ServicesImg}
                  alt="mission&vision"
                />
                </div>
              </Box>
            </Grid>
            <Grid item md={8} xs={12}>
              <Box sx={{padding: {xs: 1, sm: 2,  md: 3,} ,mt:4}}> {/**mt:{xs: 2, sm:2,  md:1,} */}
              <Typography
                  variant="h3"
                  sx={{
                    fontSize: "20px",
                    color: "#009bd6",
                    mt: 2,
                    mb: 1,
                    fontWeight: "bold",
                  }}
                >
                  Works
                </Typography>
                <Typography sx={{ fontSize: "16px",color:"#03203f" }}>{data?.works}</Typography>

                {/* <Typography
                  variant="h3"
                  sx={{
                    fontSize: "20px",
                    color: "#009bd6",
                    mt: 2,
                    mb: 1,
                    fontWeight: "bold",
                  }}
                >
                  Supply
                </Typography>
                <Typography sx={{ fontSize: "16px" ,color:"#03203f"}}>
                  {data?.supply}
                </Typography> */}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <div id="services" className="text-center" style={{marginBottom:"-4rem"}}>
        <div className="container">
          <div className="section-title">
            <h2>Our Works</h2>
          </div>
          <div className="row">
            {props.data
              ? props.data.map((d, i) => (
                  <div key={`${d.name}-${i}`} className="col-md-4">
                    {" "}
                    <Box>
                      <img
                        src={d.icon}
                        alt="Icons"
                        style={{ width: 170, height: 170, borderRadius: "50%" }}
                      />
                    </Box>
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>
        </div>
      </div>
      <Footer/> 
    </Box>
  );
};

const data = {
  works:
    "We do all kind of mechanical works like Fabrication, Erection, & Commissioning in Power, Steel & Coal industries.",
  supply:
    "We are leading manufacutrer of all kind of industrial equipments & Spares.",
};

const supply = [
  {
    id: 1,
    title: "ASH Handling Plant",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZJDDDmvF57x71yFaTmmEvIwEejta3Idz8Kjp8H4H6NPXpqxSQ4TdmGjTFJxPFD2ghrnM&usqp=CAU",
    points: [
      "Bag Filter",
      "Clinker Grinder",
      "ACI Bends ",
      "ASH Vessels",
      "Dome Valves",
      "Double Disc Valves",
      "All Equipment & Spares",
    ],
  },
  {
    id: 2,
    title: "Main Plant (BDM)",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRgqALR57iRW0WgtDwkJytmOzBBmEcUEWBLyi_eqbHZjim1cOEH1jlA_i-l0T1A22MSVSg&usqp=CAU",
    points: [
      "	Boiler Tubes",
      "	Coils",
      "	Valves ",
      "Gratings",
      "Shield Pipe & Equipment",
      "Coal",
      "All Equipment & Spares",
    ],
  },
  {
    id: 3,
    title: "ESP",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPOPARG_WmI47npB8wItnlVYcr1BcRV7CB2w&s",
    points: [
      "Collecting Electrodes",
      "	Hammer",
      "Expansion Joints. ",
      "Discharge Electrodes.",
      "GD Screen.",
      "Pin Wheel.",
      "Plain Bearing",
    ],
  },
  {
    id: 1,
    title: "Coal Handling Plant",
    img: "https://5.imimg.com/data5/SELLER/Default/2022/3/MV/GY/JI/4877528/coal-handling-plant.jpeg",
    points: [
      "	Pulley",
      "Roller",
      "Roller Brackets",
      "Shafts",
      "Repairing Jobs",
      "Fabrication Works",
      "All Equipment & Spares",
    ],
  },
];
